// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.formContainer {
  max-width: 210mm;
  margin: 0 auto;
  background: #ffffff;
  font-family: "Times New Roman", serif;
  padding: 0;
  box-sizing: border-box;
  width: 100%;
  /* Reset all margins and paddings */
  /* =========================
     TOP SECTION
  ========================= */
  /* =========================
     INFO LINES
  ========================= */
  /* =========================
     CONTRACT SECTION
  ========================= */
  /* =========================
     TITLES
  ========================= */
  /* =========================
     PRODUCTS TABLE - FIXED
  ========================= */
  /* =========================
     TEXT UTILITIES
  ========================= */
  /* =========================
     TERMS & CONDITIONS
  ========================= */
  /* =========================
     SIGNATURE ROW
  ========================= */
  /* =========================
     DECLARATION CONTAINER
  ========================= */
  /* =========================
     DOTTED LINE
  ========================= */
  /* =========================
     TWO COLUMN
  ========================= */
  /* =========================
     THREE COLUMN
  ========================= */
  /* =========================
     IMAGES
  ========================= */
  /* =========================
     FLEX UTILITIES
  ========================= */
}
.formContainer * {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.formContainer .top-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 5px 0 10px 0;
  font-size: 10px;
  width: 100%;
}
.formContainer .top-section .right {
  text-align: right;
  margin-left: auto;
}
.formContainer .top-section .right span {
  margin-left: 10px;
}
.formContainer .info-line {
  margin: 5px 0;
  font-size: 10px;
  padding: 3px 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
}
.formContainer .info-line strong {
  font-weight: bold;
}
.formContainer .contract-section {
  margin: 8px 0;
  font-size: 10px;
  text-align: justify;
  line-height: 1.3;
  width: 100%;
}
.formContainer .contract-section p {
  margin: 5px 0;
}
.formContainer .contract-title {
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  margin: 12px 0 10px;
  text-decoration: underline;
  width: 100%;
}
.formContainer .products-table {
  width: 100%;
  border-collapse: collapse;
  margin: 10px 0;
  font-size: 9px;
  table-layout: fixed;
}
.formContainer .products-table th {
  background-color: #e0e0e0;
  border: 1px solid #000;
  padding: 6px 3px;
  font-weight: bold;
  text-align: center;
  font-size: 9px;
}
.formContainer .products-table td {
  border: 1px solid #000;
  padding: 5px 3px;
  vertical-align: top;
  font-size: 9px;
}
.formContainer .products-table th:first-child,
.formContainer .products-table td:first-child {
  width: 12%;
}
.formContainer .products-table th:nth-child(2),
.formContainer .products-table td:nth-child(2) {
  width: 10%;
}
.formContainer .products-table th:nth-child(3),
.formContainer .products-table td:nth-child(3) {
  width: 10%;
}
.formContainer .products-table th:nth-child(4),
.formContainer .products-table td:nth-child(4) {
  width: 18%;
}
.formContainer .products-table th:nth-child(5),
.formContainer .products-table td:nth-child(5) {
  width: 10%;
}
.formContainer .products-table th:nth-child(6),
.formContainer .products-table td:nth-child(6) {
  width: 10%;
}
.formContainer .products-table th:nth-child(7),
.formContainer .products-table td:nth-child(7) {
  width: 6%;
}
.formContainer .products-table th:nth-child(8),
.formContainer .products-table td:nth-child(8) {
  width: 6%;
}
.formContainer .products-table th:nth-child(9),
.formContainer .products-table td:nth-child(9) {
  width: 8%;
}
.formContainer .products-table tr.total-row td {
  text-align: right;
  background-color: #f5f5f5;
  padding: 6px 8px;
}
.formContainer .products-table tr.total-row td:first-child {
  text-align: right;
}
.formContainer .products-table tr.net-total-row td {
  background-color: #e8e8e8;
  font-weight: bold;
  border-top: 2px solid #000;
}
.formContainer .text-end {
  text-align: right !important;
}
.formContainer .text-center {
  text-align: center !important;
}
.formContainer .fw-bold {
  font-weight: bold !important;
}
.formContainer .my-2 {
  margin-top: 8px;
  margin-bottom: 8px;
}
.formContainer .my-3 {
  margin-top: 12px;
  margin-bottom: 12px;
}
.formContainer .mb-2 {
  margin-bottom: 8px;
}
.formContainer .mb-4 {
  margin-bottom: 16px;
}
.formContainer .mt-4 {
  margin-top: 16px;
}
.formContainer .terms {
  font-size: 9px;
  text-align: justify;
  margin-top: 10px;
  line-height: 1.3;
  width: 100%;
}
.formContainer .terms ol {
  margin: 0;
  padding-left: 0;
  list-style: none;
  counter-reset: item;
}
.formContainer .terms ol > li {
  margin-bottom: 6px;
  counter-increment: item;
  position: relative;
  padding-left: 22px;
}
.formContainer .terms ol > li::before {
  content: counter(item) ".";
  position: absolute;
  left: 0;
  font-weight: bold;
}
.formContainer .terms ol ol {
  counter-reset: subitem;
  margin-top: 3px;
  margin-bottom: 3px;
  padding-left: 20px;
}
.formContainer .terms ol ol li {
  counter-increment: subitem;
  padding-left: 25px;
  position: relative;
  margin-bottom: 3px;
}
.formContainer .terms ol ol li::before {
  content: counter(item) "." counter(subitem);
  position: absolute;
  left: 0;
}
.formContainer .signature-row {
  display: flex;
  justify-content: space-between;
  margin-top: 25px;
  font-size: 10px;
  width: 100%;
}
.formContainer .declaration-container {
  margin-top: 20px;
  padding: 10px 0;
  width: 100%;
}
.formContainer .declaration-container .declaration-text {
  margin: 12px 0;
  text-align: justify;
  font-size: 10px;
  line-height: 1.3;
}
.formContainer .dotted-line {
  margin: 5px 0;
  padding-bottom: 3px;
  border-bottom: 1px dotted #000;
  width: 100%;
}
.formContainer .two-column {
  display: flex;
  justify-content: space-between;
  margin: 8px 0;
  font-size: 10px;
  width: 100%;
}
.formContainer .two-column div:first-child {
  text-align: left;
}
.formContainer .two-column div:last-child {
  text-align: right;
}
.formContainer .three-column {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  margin: 8px 0;
  font-size: 10px;
  width: 100%;
}
.formContainer .three-column div:first-child {
  text-align: left;
}
.formContainer .three-column div:nth-child(2) {
  text-align: center;
}
.formContainer .three-column div:last-child {
  text-align: right;
}
.formContainer img {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
}
.formContainer .d-flex {
  display: flex;
}
.formContainer .justify-content-between {
  justify-content: space-between;
}
.formContainer .justify-content-center {
  justify-content: center;
}

/* ================================
   DELIVERY CHALLAN STYLES - UPDATED
================================ */
.deliverychallancontainer {
  font-family: "Times New Roman", serif;
  background-color: #ffffff;
  max-width: 210mm;
  margin: 0 auto;
  padding: 0;
  box-sizing: border-box;
}
.deliverychallancontainer .delivery-challan {
  max-width: 100%;
  margin: 0 auto;
  background-color: white;
  padding: 8mm 12mm !important; /* Added left and right padding */
  box-sizing: border-box;
  width: 100%;
  /* Row and column utilities */
}
.deliverychallancontainer .delivery-challan .img {
  width: 100%;
  height: auto;
  margin-bottom: 15px;
}
.deliverychallancontainer .delivery-challan .document-title {
  font-size: 18px;
  font-weight: 700;
  text-align: center;
  margin: 20px 0;
  text-transform: uppercase;
  letter-spacing: 1px;
}
.deliverychallancontainer .delivery-challan .section-title {
  font-weight: 700;
  margin: 15px 0 10px 0;
  color: #333;
  font-size: 12px;
  text-transform: uppercase;
  border-bottom: 1px solid #ddd;
  padding-bottom: 5px;
}
.deliverychallancontainer .delivery-challan .party-info {
  background-color: #f9f9f9;
  padding: 12px 15px;
  border-radius: 4px;
  margin-bottom: 20px;
  border: 1px solid #e0e0e0;
}
.deliverychallancontainer .delivery-challan .party-info .info-label {
  font-weight: 600;
  color: #555;
  font-size: 10px;
}
.deliverychallancontainer .delivery-challan .party-info strong {
  font-size: 10px;
}
.deliverychallancontainer .delivery-challan .party-info .row {
  margin-bottom: 8px;
}
.deliverychallancontainer .delivery-challan .party-info .row:last-child {
  margin-bottom: 0;
}
.deliverychallancontainer .delivery-challan .table-responsive {
  width: 100%;
  overflow-x: auto;
  margin: 10px 0;
}
.deliverychallancontainer .delivery-challan .table {
  width: 100%;
  border-collapse: collapse;
  font-size: 9px;
}
.deliverychallancontainer .delivery-challan .table th {
  background-color: #e0e0e0;
  border: 1px solid #000;
  padding: 8px 6px;
  font-weight: bold;
  text-align: center;
  font-size: 9px;
}
.deliverychallancontainer .delivery-challan .table td {
  border: 1px solid #000;
  padding: 6px 6px;
  vertical-align: top;
  font-size: 9px;
}
.deliverychallancontainer .delivery-challan .table .total-row {
  background-color: #f5f5f5;
  font-weight: bold;
}
.deliverychallancontainer .delivery-challan .table .total-row td {
  font-weight: bold;
}
.deliverychallancontainer .delivery-challan .signature-section {
  margin-top: 25px;
  padding-top: 15px;
}
.deliverychallancontainer .delivery-challan .signature-section .signature-box {
  border: 1px solid #999;
  height: 60px;
  margin-top: 5px;
  border-radius: 2px;
  background-color: #fafafa;
}
.deliverychallancontainer .delivery-challan .signature-section .footer-note {
  font-size: 9px;
  color: #666;
  margin-top: 5px;
}
.deliverychallancontainer .delivery-challan .row {
  display: flex;
  flex-wrap: wrap;
  margin: 0;
}
.deliverychallancontainer .delivery-challan .row [class*=col-] {
  padding: 0 8px;
}
.deliverychallancontainer .delivery-challan .col-md-6 {
  flex: 0 0 50%;
  max-width: 50%;
}
.deliverychallancontainer .delivery-challan .col-sm-3 {
  flex: 0 0 25%;
  max-width: 25%;
}
.deliverychallancontainer .delivery-challan .col-sm-9 {
  flex: 0 0 75%;
  max-width: 75%;
}
.deliverychallancontainer .delivery-challan .col-12 {
  flex: 0 0 100%;
  max-width: 100%;
}
.deliverychallancontainer .delivery-challan .mb-2 {
  margin-bottom: 8px;
}
.deliverychallancontainer .delivery-challan .mb-4 {
  margin-bottom: 16px;
}
.deliverychallancontainer .delivery-challan .mt-4 {
  margin-top: 16px;
}
.deliverychallancontainer .delivery-challan .text-center {
  text-align: center;
}
.deliverychallancontainer .delivery-challan .text-end {
  text-align: right;
}

/* ================================
   A4 PAGE SETUP
================================ */
@page {
  size: A4;
  margin: 10mm 15mm;
}
@media print {
  html, body {
    margin: 0 !important;
    padding: 0 !important;
    background: white;
    width: 100%;
  }
  .formContainer {
    margin: 0 auto !important;
    padding: 0 !important;
    width: 100%;
    max-width: 210mm;
    box-sizing: border-box;
  }
  .deliverychallancontainer {
    margin: 0 auto !important;
    padding: 0 !important;
  }
  .deliverychallancontainer .delivery-challan {
    padding: 5mm 10mm !important;
    margin: 0 auto !important;
  }
  .products-table {
    page-break-inside: avoid;
  }
  .contract-title {
    page-break-after: avoid;
  }
  p, li, .info-line {
    orphans: 2;
    widows: 2;
  }
  .no-print {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/customer_app/Customer_V5/ERF/erf_Printout.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,qCAAA;EACA,UAAA;EACA,sBAAA;EACA,WAAA;EAEA,mCAAA;EAOA;;6BAAA;EAqBA;;6BAAA;EAiBA;;6BAAA;EAeA;;6BAAA;EAYA;;6BAAA;EA8FA;;6BAAA;EAqCA;;6BAAA;EAoDA;;6BAAA;EAWA;;6BAAA;EAgBA;;6BAAA;EAUA;;6BAAA;EAmBA;;6BAAA;EAwBA;;6BAAA;EAUA;;6BAAA;AA/SF;AAzCE;EACE,SAAA;EACA,UAAA;EACA,sBAAA;AA2CJ;AArCE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;EACA,WAAA;AAuCJ;AArCI;EACE,iBAAA;EACA,iBAAA;AAuCN;AArCM;EACE,iBAAA;AAuCR;AA/BE;EACE,aAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,8BAAA;EACA,eAAA;EACA,WAAA;AAiCJ;AA/BI;EACE,iBAAA;AAiCN;AA1BE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;AA4BJ;AA1BI;EACE,aAAA;AA4BN;AArBE;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,0BAAA;EACA,WAAA;AAuBJ;AAjBE;EACE,WAAA;EACA,yBAAA;EACA,cAAA;EACA,cAAA;EACA,mBAAA;AAmBJ;AAjBI;EACE,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAmBN;AAhBI;EACE,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAkBN;AAfI;;EAEE,UAAA;AAiBN;AAdI;;EAEE,UAAA;AAgBN;AAbI;;EAEE,UAAA;AAeN;AAZI;;EAEE,UAAA;AAcN;AAXI;;EAEE,UAAA;AAaN;AAVI;;EAEE,UAAA;AAYN;AATI;;EAEE,SAAA;AAWN;AARI;;EAEE,SAAA;AAUN;AAPI;;EAEE,SAAA;AASN;AAJQ;EACE,iBAAA;EACA,yBAAA;EACA,gBAAA;AAMV;AAJU;EACE,iBAAA;AAMZ;AAAQ;EACE,yBAAA;EACA,iBAAA;EACA,0BAAA;AAEV;AAOE;EACE,4BAAA;AALJ;AAQE;EACE,6BAAA;AANJ;AASE;EACE,4BAAA;AAPJ;AAUE;EACE,eAAA;EACA,kBAAA;AARJ;AAWE;EACE,gBAAA;EACA,mBAAA;AATJ;AAYE;EACE,kBAAA;AAVJ;AAaE;EACE,mBAAA;AAXJ;AAcE;EACE,gBAAA;AAZJ;AAkBE;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;AAhBJ;AAkBI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAhBN;AAkBM;EACE,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;AAhBR;AAkBQ;EACE,0BAAA;EACA,kBAAA;EACA,OAAA;EACA,iBAAA;AAhBV;AAoBM;EACE,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AAlBR;AAoBQ;EACE,0BAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AAlBV;AAoBU;EACE,2CAAA;EACA,kBAAA;EACA,OAAA;AAlBZ;AA4BE;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;AA1BJ;AAgCE;EACE,gBAAA;EACA,eAAA;EACA,WAAA;AA9BJ;AAgCI;EACE,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AA9BN;AAqCE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;AAnCJ;AAyCE;EACE,aAAA;EACA,8BAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;AAvCJ;AAyCI;EACE,gBAAA;AAvCN;AA0CI;EACE,iBAAA;AAxCN;AA+CE;EACE,aAAA;EACA,qCAAA;EACA,QAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;AA7CJ;AA+CI;EACE,gBAAA;AA7CN;AAgDI;EACE,kBAAA;AA9CN;AAiDI;EACE,iBAAA;AA/CN;AAsDE;EACE,eAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AApDJ;AA0DE;EACE,aAAA;AAxDJ;AA2DE;EACE,8BAAA;AAzDJ;AA4DE;EACE,uBAAA;AA1DJ;;AA8DA;;kCAAA;AAGA;EACE,qCAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,UAAA;EACA,sBAAA;AA3DF;AA6DE;EACE,eAAA;EACA,cAAA;EACA,uBAAA;EACA,4BAAA,EAAA,iCAAA;EACA,sBAAA;EACA,WAAA;EA6GA,6BAAA;AAvKJ;AA4DI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AA1DN;AA6DI;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;AA3DN;AA8DI;EACE,gBAAA;EACA,qBAAA;EACA,WAAA;EACA,eAAA;EACA,yBAAA;EACA,6BAAA;EACA,mBAAA;AA5DN;AA+DI;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;AA7DN;AA+DM;EACE,gBAAA;EACA,WAAA;EACA,eAAA;AA7DR;AAgEM;EACE,eAAA;AA9DR;AAiEM;EACE,kBAAA;AA/DR;AAiEQ;EACE,gBAAA;AA/DV;AAoEI;EACE,WAAA;EACA,gBAAA;EACA,cAAA;AAlEN;AAqEI;EACE,WAAA;EACA,yBAAA;EACA,cAAA;AAnEN;AAqEM;EACE,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAnER;AAsEM;EACE,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AApER;AAuEM;EACE,yBAAA;EACA,iBAAA;AArER;AAuEQ;EACE,iBAAA;AArEV;AA0EI;EACE,gBAAA;EACA,iBAAA;AAxEN;AA0EM;EACE,sBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;AAxER;AA2EM;EACE,cAAA;EACA,WAAA;EACA,eAAA;AAzER;AA8EI;EACE,aAAA;EACA,eAAA;EACA,SAAA;AA5EN;AA8EM;EACE,cAAA;AA5ER;AAgFI;EACE,aAAA;EACA,cAAA;AA9EN;AAiFI;EACE,aAAA;EACA,cAAA;AA/EN;AAkFI;EACE,aAAA;EACA,cAAA;AAhFN;AAmFI;EACE,cAAA;EACA,eAAA;AAjFN;AAoFI;EACE,kBAAA;AAlFN;AAqFI;EACE,mBAAA;AAnFN;AAsFI;EACE,gBAAA;AApFN;AAuFI;EACE,kBAAA;AArFN;AAwFI;EACE,iBAAA;AAtFN;;AA2FA;;kCAAA;AAGA;EACE,QAAA;EACA,iBAAA;AAxFF;AA2FA;EACE;IACE,oBAAA;IACA,qBAAA;IACA,iBAAA;IACA,WAAA;EAzFF;EA4FA;IACE,yBAAA;IACA,qBAAA;IACA,WAAA;IACA,gBAAA;IACA,sBAAA;EA1FF;EA6FA;IACE,yBAAA;IACA,qBAAA;EA3FF;EA6FE;IACE,4BAAA;IACA,yBAAA;EA3FJ;EA+FA;IACE,wBAAA;EA7FF;EAgGA;IACE,uBAAA;EA9FF;EAiGA;IACE,UAAA;IACA,SAAA;EA/FF;EAkGA;IACE,aAAA;EAhGF;AACF","sourcesContent":[".formContainer {\n  max-width: 210mm;\n  margin: 0 auto;\n  background: #ffffff;\n  font-family: \"Times New Roman\", serif;\n  padding: 0;\n  box-sizing: border-box;\n  width: 100%;\n\n  /* Reset all margins and paddings */\n  * {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n  }\n\n  /* =========================\n     TOP SECTION\n  ========================= */\n  .top-section {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin: 5px 0 10px 0;\n    font-size: 10px;\n    width: 100%;\n\n    .right {\n      text-align: right;\n      margin-left: auto;\n      \n      span {\n        margin-left: 10px;\n      }\n    }\n  }\n\n  /* =========================\n     INFO LINES\n  ========================= */\n  .info-line {\n    margin: 5px 0;\n    font-size: 10px;\n    padding: 3px 0;\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    width: 100%;\n\n    strong {\n      font-weight: bold;\n    }\n  }\n\n  /* =========================\n     CONTRACT SECTION\n  ========================= */\n  .contract-section {\n    margin: 8px 0;\n    font-size: 10px;\n    text-align: justify;\n    line-height: 1.3;\n    width: 100%;\n\n    p {\n      margin: 5px 0;\n    }\n  }\n\n  /* =========================\n     TITLES\n  ========================= */\n  .contract-title {\n    text-align: center;\n    font-size: 14px;\n    font-weight: bold;\n    margin: 12px 0 10px;\n    text-decoration: underline;\n    width: 100%;\n  }\n\n  /* =========================\n     PRODUCTS TABLE - FIXED\n  ========================= */\n  .products-table {\n    width: 100%;\n    border-collapse: collapse;\n    margin: 10px 0;\n    font-size: 9px;\n    table-layout: fixed;\n\n    th {\n      background-color: #e0e0e0;\n      border: 1px solid #000;\n      padding: 6px 3px;\n      font-weight: bold;\n      text-align: center;\n      font-size: 9px;\n    }\n\n    td {\n      border: 1px solid #000;\n      padding: 5px 3px;\n      vertical-align: top;\n      font-size: 9px;\n    }\n\n    th:first-child,\n    td:first-child {\n      width: 12%;\n    }\n\n    th:nth-child(2),\n    td:nth-child(2) {\n      width: 10%;\n    }\n\n    th:nth-child(3),\n    td:nth-child(3) {\n      width: 10%;\n    }\n\n    th:nth-child(4),\n    td:nth-child(4) {\n      width: 18%;\n    }\n\n    th:nth-child(5),\n    td:nth-child(5) {\n      width: 10%;\n    }\n\n    th:nth-child(6),\n    td:nth-child(6) {\n      width: 10%;\n    }\n\n    th:nth-child(7),\n    td:nth-child(7) {\n      width: 6%;\n    }\n\n    th:nth-child(8),\n    td:nth-child(8) {\n      width: 6%;\n    }\n\n    th:nth-child(9),\n    td:nth-child(9) {\n      width: 8%;\n    }\n\n    tr {\n      &.total-row {\n        td {\n          text-align: right;\n          background-color: #f5f5f5;\n          padding: 6px 8px;\n          \n          &:first-child {\n            text-align: right;\n          }\n        }\n      }\n      \n      &.net-total-row {\n        td {\n          background-color: #e8e8e8;\n          font-weight: bold;\n          border-top: 2px solid #000;\n        }\n      }\n    }\n  }\n\n  /* =========================\n     TEXT UTILITIES\n  ========================= */\n  .text-end {\n    text-align: right !important;\n  }\n  \n  .text-center {\n    text-align: center !important;\n  }\n  \n  .fw-bold {\n    font-weight: bold !important;\n  }\n  \n  .my-2 {\n    margin-top: 8px;\n    margin-bottom: 8px;\n  }\n  \n  .my-3 {\n    margin-top: 12px;\n    margin-bottom: 12px;\n  }\n  \n  .mb-2 {\n    margin-bottom: 8px;\n  }\n  \n  .mb-4 {\n    margin-bottom: 16px;\n  }\n  \n  .mt-4 {\n    margin-top: 16px;\n  }\n\n  /* =========================\n     TERMS & CONDITIONS\n  ========================= */\n  .terms {\n    font-size: 9px;\n    text-align: justify;\n    margin-top: 10px;\n    line-height: 1.3;\n    width: 100%;\n\n    ol {\n      margin: 0;\n      padding-left: 0;\n      list-style: none;\n      counter-reset: item;\n\n      > li {\n        margin-bottom: 6px;\n        counter-increment: item;\n        position: relative;\n        padding-left: 22px;\n\n        &::before {\n          content: counter(item) \".\";\n          position: absolute;\n          left: 0;\n          font-weight: bold;\n        }\n      }\n\n      ol {\n        counter-reset: subitem;\n        margin-top: 3px;\n        margin-bottom: 3px;\n        padding-left: 20px;\n\n        li {\n          counter-increment: subitem;\n          padding-left: 25px;\n          position: relative;\n          margin-bottom: 3px;\n\n          &::before {\n            content: counter(item) \".\" counter(subitem);\n            position: absolute;\n            left: 0;\n          }\n        }\n      }\n    }\n  }\n\n  /* =========================\n     SIGNATURE ROW\n  ========================= */\n  .signature-row {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 25px;\n    font-size: 10px;\n    width: 100%;\n  }\n\n  /* =========================\n     DECLARATION CONTAINER\n  ========================= */\n  .declaration-container {\n    margin-top: 20px;\n    padding: 10px 0;\n    width: 100%;\n    \n    .declaration-text {\n      margin: 12px 0;\n      text-align: justify;\n      font-size: 10px;\n      line-height: 1.3;\n    }\n  }\n  \n  /* =========================\n     DOTTED LINE\n  ========================= */\n  .dotted-line {\n    margin: 5px 0;\n    padding-bottom: 3px;\n    border-bottom: 1px dotted #000;\n    width: 100%;\n  }\n  \n  /* =========================\n     TWO COLUMN\n  ========================= */\n  .two-column {\n    display: flex;\n    justify-content: space-between;\n    margin: 8px 0;\n    font-size: 10px;\n    width: 100%;\n    \n    div:first-child {\n      text-align: left;\n    }\n    \n    div:last-child {\n      text-align: right;\n    }\n  }\n  \n  /* =========================\n     THREE COLUMN\n  ========================= */\n  .three-column {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 8px;\n    margin: 8px 0;\n    font-size: 10px;\n    width: 100%;\n    \n    div:first-child {\n      text-align: left;\n    }\n    \n    div:nth-child(2) {\n      text-align: center;\n    }\n    \n    div:last-child {\n      text-align: right;\n    }\n  }\n  \n  /* =========================\n     IMAGES\n  ========================= */\n  img {\n    max-width: 100%;\n    height: auto;\n    display: block;\n    margin: 0 auto;\n  }\n  \n  /* =========================\n     FLEX UTILITIES\n  ========================= */\n  .d-flex {\n    display: flex;\n  }\n  \n  .justify-content-between {\n    justify-content: space-between;\n  }\n  \n  .justify-content-center {\n    justify-content: center;\n  }\n}\n\n/* ================================\n   DELIVERY CHALLAN STYLES - UPDATED\n================================ */\n.deliverychallancontainer {\n  font-family: \"Times New Roman\", serif;\n  background-color: #ffffff;\n  max-width: 210mm;\n  margin: 0 auto;\n  padding: 0;\n  box-sizing: border-box;\n\n  .delivery-challan {\n    max-width: 100%;\n    margin: 0 auto;\n    background-color: white;\n    padding: 8mm 12mm !important; /* Added left and right padding */\n    box-sizing: border-box;\n    width: 100%;\n\n    .img {\n      width: 100%;\n      height: auto;\n      margin-bottom: 15px;\n    }\n\n    .document-title {\n      font-size: 18px;\n      font-weight: 700;\n      text-align: center;\n      margin: 20px 0;\n      text-transform: uppercase;\n      letter-spacing: 1px;\n    }\n\n    .section-title {\n      font-weight: 700;\n      margin: 15px 0 10px 0;\n      color: #333;\n      font-size: 12px;\n      text-transform: uppercase;\n      border-bottom: 1px solid #ddd;\n      padding-bottom: 5px;\n    }\n\n    .party-info {\n      background-color: #f9f9f9;\n      padding: 12px 15px;\n      border-radius: 4px;\n      margin-bottom: 20px;\n      border: 1px solid #e0e0e0;\n      \n      .info-label {\n        font-weight: 600;\n        color: #555;\n        font-size: 10px;\n      }\n      \n      strong {\n        font-size: 10px;\n      }\n      \n      .row {\n        margin-bottom: 8px;\n        \n        &:last-child {\n          margin-bottom: 0;\n        }\n      }\n    }\n\n    .table-responsive {\n      width: 100%;\n      overflow-x: auto;\n      margin: 10px 0;\n    }\n\n    .table {\n      width: 100%;\n      border-collapse: collapse;\n      font-size: 9px;\n      \n      th {\n        background-color: #e0e0e0;\n        border: 1px solid #000;\n        padding: 8px 6px;\n        font-weight: bold;\n        text-align: center;\n        font-size: 9px;\n      }\n      \n      td {\n        border: 1px solid #000;\n        padding: 6px 6px;\n        vertical-align: top;\n        font-size: 9px;\n      }\n      \n      .total-row {\n        background-color: #f5f5f5;\n        font-weight: bold;\n        \n        td {\n          font-weight: bold;\n        }\n      }\n    }\n\n    .signature-section {\n      margin-top: 25px;\n      padding-top: 15px;\n      \n      .signature-box {\n        border: 1px solid #999;\n        height: 60px;\n        margin-top: 5px;\n        border-radius: 2px;\n        background-color: #fafafa;\n      }\n      \n      .footer-note {\n        font-size: 9px;\n        color: #666;\n        margin-top: 5px;\n      }\n    }\n\n    /* Row and column utilities */\n    .row {\n      display: flex;\n      flex-wrap: wrap;\n      margin: 0;\n      \n      [class*=\"col-\"] {\n        padding: 0 8px;\n      }\n    }\n    \n    .col-md-6 {\n      flex: 0 0 50%;\n      max-width: 50%;\n    }\n    \n    .col-sm-3 {\n      flex: 0 0 25%;\n      max-width: 25%;\n    }\n    \n    .col-sm-9 {\n      flex: 0 0 75%;\n      max-width: 75%;\n    }\n    \n    .col-12 {\n      flex: 0 0 100%;\n      max-width: 100%;\n    }\n    \n    .mb-2 {\n      margin-bottom: 8px;\n    }\n    \n    .mb-4 {\n      margin-bottom: 16px;\n    }\n    \n    .mt-4 {\n      margin-top: 16px;\n    }\n    \n    .text-center {\n      text-align: center;\n    }\n    \n    .text-end {\n      text-align: right;\n    }\n  }\n}\n\n/* ================================\n   A4 PAGE SETUP\n================================ */\n@page {\n  size: A4;\n  margin: 10mm 15mm;\n}\n\n@media print {\n  html, body {\n    margin: 0 !important;\n    padding: 0 !important;\n    background: white;\n    width: 100%;\n  }\n\n  .formContainer {\n    margin: 0 auto !important;\n    padding: 0 !important;\n    width: 100%;\n    max-width: 210mm;\n    box-sizing: border-box;\n  }\n  \n  .deliverychallancontainer {\n    margin: 0 auto !important;\n    padding: 0 !important;\n    \n    .delivery-challan {\n      padding: 5mm 10mm !important;\n      margin: 0 auto !important;\n    }\n  }\n\n  .products-table {\n    page-break-inside: avoid;\n  }\n  \n  .contract-title {\n    page-break-after: avoid;\n  }\n  \n  p, li, .info-line {\n    orphans: 2;\n    widows: 2;\n  }\n  \n  .no-print {\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
